import { defineMessages, useIntl } from "react-intl";

import {
  queryClient,
  MutationActions,
  QueryKeys,
  useEntityMutation,
} from "@/api/core";
import { updatePredictionStatusCache } from "@/api/predictions/utils";
import { useApi } from "@/hooks";
import { statusSchema } from "@/schemas";
import toast from "@/toast";

import { updateStatusCache } from "../utils";

const messages = defineMessages({
  deletedTruth: {
    id: "status.error.deletedTruth",
    defaultMessage: "This Truth has been deleted and is no longer available.",
  },
});
interface Variables {
  id: string;
}

function useUnreblogStatus() {
  const intl = useIntl();
  const api = useApi();

  return useEntityMutation({
    globalQueryKey: QueryKeys.statuses.global,
    idAttributeFromVariables: "id",
    action: MutationActions.UPDATE,
    schema: statusSchema,
    skipOnSuccess: true, // TODO: Remove once API added optimistic updates.
    mutationFn: (variables: Variables) =>
      api.post(`/api/v1/statuses/${variables.id}/unreblog`),
    onMutate(variables) {
      const [prevStatus] = updateStatusCache(variables.id, (prevStatus) => ({
        reblogged: false,
        reblogs_count: prevStatus.reblogs_count - 1,
      }));
      const [prevPredictionStatus] = updatePredictionStatusCache(
        variables.id,
        (prevStatus) => ({
          reblogged: false,
          reblogs_count: prevStatus.reblogs_count - 1,
        }),
      );

      return { prevPredictionStatus, prevStatus };
    },
    onError(error, variables, context) {
      if (error.response?.status === 404) {
        toast.error(intl.formatMessage(messages.deletedTruth));
      }
      if (context?.prevStatus) {
        queryClient.setQueryData(
          QueryKeys.statuses.detail(variables.id),
          context.prevStatus,
        );
      }
      if (context?.prevPredictionStatus) {
        queryClient.setQueryData(
          QueryKeys.predictions.prediction(variables.id),
          context.prevPredictionStatus,
        );
      }
    },
  });
}

export { useUnreblogStatus };
